import { Component, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { Url } from './common';
import { NavigationHistoryService } from './common/navigation-history.service';
import { VersionCheckService } from './common/version.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
   title = 'mnc';
   BORDER_THICKNESS = 2;
   @ViewChild('zoneSelect') zoneSelect!: ElementRef<HTMLDivElement>;
   overlay:any; outline:any;
   element:any; dimensions:any;
  screenshotMode = false;

  constructor(@Inject(LOCALE_ID) public locale: string, public intlService: IntlService,private translate: TranslateService,private navigationService:NavigationHistoryService,private versionCheckService:VersionCheckService) {
     this.setLang();
  }

  ngOnInit(): void {
    this.changePageTitle();
    this.navigationService.startSaveHistory();
    this.versionCheckService.initVersionCheck();
  }

  changePageTitle()
  {
    document.title = Url.isDev ? 'Skynet Dev': Url.isStaging ? 'Skynet Staging'  :'Skynet';
  }

  setLang()
  {
    this.translate.setDefaultLang('de');

    const lang = localStorage.getItem('language');
    if (lang) {
      this.translate.use(lang);
    } else {
      this.translate.use('de');
      localStorage.setItem('language','de');
    }

    if(lang == "fr")
    {
      this.locale = 'fr-FR';
      (<CldrIntlService>this.intlService).localeId = 'fr-FR';
    }
    else if(lang == "it")
    {
      this.locale = 'it-IT';
      (<CldrIntlService>this.intlService).localeId = 'it-IT';
    }
    else if(lang == "de")
    {
      this.locale = 'de-DE';
      (<CldrIntlService>this.intlService).localeId = 'de-DE';
    }
    else
    {
      this.locale = 'en-EN';
      (<CldrIntlService>this.intlService).localeId = 'en-EN';
    }
  }




}
